import React, { useState } from 'react'
import { useParams } from 'react-router'
import { Icon, AccordionTitle, AccordionContent, Accordion, Popup } from 'semantic-ui-react'
import { KIT_STATUS } from '../List/constants'
import style from './MoreDetails.module.css'

const MoreDetails = ({ data }) => {
  const { kitId } = useParams()
  const [open, setOpen] = useState(false)

  const { kits } = data
  const { kit, tracking, trackingUrl } = kits.length && kits.find(({ kit }) => kit.id === kitId)

  const url = trackingUrl?.split(';')

  // get the status of the last tracking entry
  const latest = tracking?.at(-1)
  const status = latest?.status.toUpperCase()

  let href
  switch (status) {
    case KIT_STATUS.SHIPPED:
      href = url[0]
      break
    case KIT_STATUS.RETURN:
    case KIT_STATUS.RECEIVED:
      href = url[1]
      break
    default:
      href = ''
  }

  const skuKitId = kit?.skuKitId
  const accessionId = data?.fillerId || (data.fillerId === '' && data.fillerId)
  const orderType = data?.orderType

  return (
    <Accordion className={style.container}>
      <AccordionTitle active={open} onClick={() => setOpen(!open)} className={style.title}>
        More Details
        <Icon name="dropdown" />
      </AccordionTitle>
      <AccordionContent active={open} className={style.content}>
        {skuKitId && (
          <span className={style.detailsItem}>
            <strong>Test Kit SKU #:</strong> {skuKitId}
          </span>
        )}

        {accessionId && (
          <span className={style.detailsItem}>
            <strong>Accession #:</strong> {accessionId}
          </span>
        )}

        {orderType && (
          <span className={style.detailsItem}>
            <strong>Payment Method:</strong> {orderType}
          </span>
        )}

        <div>
          {href && (
            <Popup
              content={href}
              trigger={
                <a href={href} target="_blank" rel="noopener noreferrer">
                  Tracking URL
                </a>
              }
              position="bottom left"
            />
          )}
        </div>
      </AccordionContent>
    </Accordion>
  )
}

export default MoreDetails
